module.exports = __webpack_public_path__ + "static/media/questionsBoard.5956718f.svg";